import { AfterViewInit, Directive, ElementRef, inject, input, OnDestroy } from '@angular/core';

@Directive({
    selector: '[stbyAutofocus]',
})
export class AutofocusDirective implements AfterViewInit, OnDestroy {
    private el = inject(ElementRef);

    readonly autofocus = input(true, {
        alias: 'stbyAutofocus',
        transform: (value: boolean) => value !== false && value !== null && value !== undefined,
    });
    private observer: MutationObserver;

    ngAfterViewInit() {
        if (!this.autofocus()) return;

        setTimeout(() => {
            if (!this.el.nativeElement.hidden) {
                this.el.nativeElement.focus();
            }

            // Create a MutationObserver to observe changes in the "hidden" attribute on the element
            this.observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
                        if (!this.el.nativeElement.hidden) {
                            this.el.nativeElement.focus();
                        }
                    }
                }
            });

            this.observer.observe(this.el.nativeElement, { attributes: true });
        }, 100);
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
